import { ScrollBar } from "./ScrollBar";
export class HScrollBar extends ScrollBar {
    initialize() {
        super.initialize();
        this.slider.isVertical = false;
    }
}
